var _Defs, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Defs, ClipPath, Path, G } from "react-native-svg";
var SvgDekoTop = function SvgDekoTop(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 137
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "deko_top_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    "data-name": "Rechteck 23",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h430v137H0z"
  })))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    "data-name": "Gruppe maskieren 3",
    clipPath: "url(#deko_top_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M53.85 92.297c52.75 43.43 74.14 74.95 173.4-2.56 142.44-111.22 289.44-35.44 368.03 4.71v-431.04H0v403.86a114.092 114.092 0 0 1 53.85 25.03Z",
    fill: "#576749"
  }))));
};
export default SvgDekoTop;